import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  selector: "select-input-type",
  templateUrl: "./select-input.type.html",
  styleUrls: ["./select-input.type.scss"],
})
export class SelectInputTypeComponent extends FieldType<FieldTypeConfig> {}
